module.exports = __webpack_public_path__ + "static/media/PC.9927ecba.PNG";